import { ComponentProps, ReactNode } from 'react';

import { Button, SelectModal } from '@pukka/ui-components';

interface OutletSelectorV2HeaderProps<T>
  extends ComponentProps<Exclude<ComponentProps<typeof SelectModal<T>>['header'], undefined | ReactNode>> {}

function OutletSelectorV2Header<T>({ max, items, canSelectAll }: OutletSelectorV2HeaderProps<T>) {
  const wording = items.size <= max ? 'Select Outlet(s)' : `Select up to ${max} Outlet(s)`;

  return (
    <>
      <SelectModal.Filter />
      <div className="-mb-3 ml-2 mt-4 flex items-center justify-between">
        <div className="text-sm font-bold text-black">{wording}</div>
        {canSelectAll && items.size > 0 && items.size <= max ? (
          <SelectModal.ToggleAll>
            {({ onClick, selected: isAllSelected }) => {
              let selectAllText = 'Select All';

              if (isAllSelected) {
                selectAllText = 'Deselect All';
              }

              return (
                <Button variant="secondary" onClick={onClick}>
                  {selectAllText}
                </Button>
              );
            }}
          </SelectModal.ToggleAll>
        ) : null}
      </div>
    </>
  );
}

export { OutletSelectorV2Header };
